import React, { lazy } from "react";
import ReactGA from "react-ga";
import axios from "axios";

ReactGA.initialize(process.env.REACT_APP_GA_ID);
ReactGA.pageview(window.location.host);

//import page from '../assets/page.json';
let page = window.page;

const BasicTemplate = lazy(() => import("../pages/templates/BasicTemplate"));
const PrePublish = lazy(() => import("../pages/templates/PrePublish"));
const Private = lazy(() => import("../pages/templates/Private"));
/*const NewTemplate = lazy (() => import('../pages/templates/NewTemplate')  ); */

axios.defaults.baseURL = `${process.env.REACT_APP_BE_URL}/api`;
axios.defaults.withCredentials = true;

export default function Landing() {

  // Page templates are added here
  switch (page.template_layout) {
    case "pre-publish": {
      return <PrePublish page={page} />;
    }

    case "private":
      return (
        <Private
          page={page}
        />
      );

    // case 'new-template': {
    // 	return <NewTemplate page={page} />
    // }

    default:
      return <BasicTemplate page={page} />;
  }
}
